"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_style_selector_html_1 = __importDefault(require("./widget-style-selector.html"));
(function (module) {
    'use strict';
    WidgetStyleController.$inject = [
        '$scope',
        '$filter',
        'pr.globalOptionsService',
        'prTextFormatsHelper',
        'widget.componentBase.colorPaletteService',
        'prEventService',
        'prFlowingPages',
        'prCustomWidgetService',
        'pr.STYLE_FORMATS'
    ];
    module.constant('pr.STYLE_FORMATS', {
        BODY_TEXT_FORMATS: 'bodyTextFormats',
        TABLE_BODY_TEXT: 'tableBodyTextFormats',
        TABLE_HEADER_TEXT: 'tableHeaderTextFormats',
        CHART_TEXT: 'chartTextFormats',
        RESPONSE_COUNT_NUMBER: 'responseCountNumberFormats',
        RESPONSE_COUNT_LABEL: 'responseCountLabelFormats',
        FILTER_SUMMARY_TEXT_FORMATS: 'filterSummaryTextFormats',
        TABLE_BODY_DENSITY: 'tableBodyDensity'
    });
    function WidgetStyleController($scope, $filter, globalOptionsService, formatHelper, colorPaletteService, eventService, flowingPages, customWidgetService, FORMATS) {
        var $ctrl = this, TEXT_FORMAT_OPTIONS = ['FONT', 'SIZE', 'COLOR', 'BOLD'], ALIGN_OPTIONS = ['ALIGN_LEFT', 'ALIGN_CENTER', 'ALIGN_RIGHT'], TABLE_WIDGETS = ['eng.table', 'eng.stats', 'eng.grid'], CHART_WIDGETS = ['eng.bar', 'eng.line', 'eng.pie', 'eng.gauge', 'eng.breakdownbar'], CHART_NO_SIZE = ['eng.gauge', 'eng.breakdownbar'], HEADER_PREFIX = 'HEADER_STYLE_', BODY_PREFIX = 'BODY_STYLE_', TABLE_DENSITY_PREFIX = 'TABLE_DENSITY_STYLE_', CHART_PREFIX = 'CHART_STYLE_', FILTER_SUMMARY_PREFIX = 'FILTER_SUMMARY_STYLE_', RESPONSE_COUNT_NUMBER = 'RESPONSE_COUNT_NUMBER_', RESPONSE_COUNT_LABEL = 'RESPONSE_COUNT_LABEL_';
        var chartAdvSections = {
            'eng.bar': [
                { label: 'X_AXIS_TEXT' },
                { label: 'Y_AXIS_TEXT' },
                { label: 'LEGEND_TEXT' }
            ],
            'eng.line': [
                { label: 'X_AXIS_TEXT' },
                { label: 'Y_AXIS_TEXT' },
                { label: 'LEGEND_TEXT' }
            ],
            'eng.pie': [
                { label: 'LABEL_TEXT' },
                { label: 'LEGEND_TEXT' }
            ],
            'eng.breakdownbar': [
                { label: 'LABEL_TEXT' },
                { label: 'LEGEND_TEXT' }
            ],
            'eng.gauge': [
                { label: 'METRIC_TEXT' },
                { label: 'SCALE_TEXT' }
            ]
        };
        var filterSummarySections = [
            { label: 'FILTER_NAME' },
            { label: 'FILTER_VALUE' },
            { label: 'ALIGNMENT' }
        ];
        var customTableWidgets = customWidgetService.getTableWidgets();
        TABLE_WIDGETS = TABLE_WIDGETS.concat(customTableWidgets);
        $ctrl.colorPaletteService = colorPaletteService;
        $scope.$ctrl = $ctrl;
        $scope.$watch('$ctrl.currentStyle', function () {
            // Update when switching between widgets with sidebar open
            if ($ctrl.isTableWidget()) {
                $ctrl.widgetStyle = validateTableStyle($ctrl.currentStyle);
                updateTableTextFormats();
            }
            else if ($ctrl.isChartWidget()) {
                $ctrl.widgetStyle = validateChartStyle($ctrl.currentStyle);
                updateChartTextFormats();
            }
            else if ($ctrl.widgetType === 'pr.filtersummary') {
                $ctrl.widgetStyle = validateFilterSummaryStyle($ctrl.currentStyle);
                updateFilterSummaryTextFormats();
            }
            eventService.stream($ctrl.widgetId).on('widgetStyleChanged', function () {
                // Seems redundant, but when outside of watch it does not re-subscribe when changing
                // widgets with sidebar open. Without it, the button labels do not update on reset default
                if ($ctrl.isTableWidget()) {
                    $ctrl.widgetStyle = validateTableStyle($ctrl.currentStyle);
                    updateTableTextFormats();
                }
                else if ($ctrl.isChartWidget()) {
                    $ctrl.widgetStyle = validateChartStyle($ctrl.currentStyle);
                    updateChartTextFormats();
                }
                else if ($ctrl.widgetType === 'pr.filtersummary') {
                    $ctrl.widgetStyle = validateFilterSummaryStyle($ctrl.currentStyle);
                    updateFilterSummaryTextFormats();
                }
            });
        });
        var textFormatOptions = formatHelper.getSubsetFormatOptions(TEXT_FORMAT_OPTIONS);
        angular.extend($ctrl, {
            responseCountNumberOptions: _.cloneDeep(textFormatOptions),
            responseCountLabelOptions: _.cloneDeep(textFormatOptions),
            tableHeaderTextFormatOptions: _.cloneDeep(textFormatOptions),
            tableBodyTextFormatOptions: _.cloneDeep(textFormatOptions),
            chartTextFormatOptions: _.cloneDeep(textFormatOptions),
            filterTextFormatOptions: _.cloneDeep(textFormatOptions),
            alignOptions: formatHelper.getSubsetFormatOptions(ALIGN_OPTIONS),
            chartAdvSections: chartAdvSections,
            filterSummarySections: filterSummarySections,
            isAdvResponseCount: false,
            $onInit: function () {
                // check if style is valid
                if ($ctrl.isTableWidget()) {
                    $ctrl.widgetStyle = validateTableStyle($ctrl.currentStyle);
                    updateTableTextFormats();
                }
                else if ($ctrl.isChartWidget()) {
                    $ctrl.widgetStyle = validateChartStyle($ctrl.currentStyle);
                    updateChartTextFormats();
                }
                else if ($ctrl.widgetType === 'pr.filtersummary') {
                    $ctrl.widgetStyle = validateFilterSummaryStyle($ctrl.currentStyle);
                    updateFilterSummaryTextFormats();
                } // only supplement part of style object that is not valid
                $ctrl.isAdvResponseCount = !_.isEqual($ctrl.responseCountNumberOptions, $ctrl.responseCountLabelOptions);
            },
            isTableWidget: function () {
                return _.includes(TABLE_WIDGETS, $ctrl.widgetType);
            },
            isChartWidget: function () {
                return _.includes(CHART_WIDGETS, $ctrl.widgetType);
            },
            isAlignmentSeclected: function (val) {
                return $ctrl.filterSummarySections[2].ALIGNMENT === val;
            },
            convertAdvResponseCount: function () {
                $ctrl.isAdvResponseCount = !$ctrl.isAdvResponseCount;
                if (!$ctrl.isAdvResponseCount) {
                    // reset to default when going from advanced to basic
                    $ctrl.resetResponseCount();
                }
            },
            changeResponseCount: function (name, value) {
                $ctrl.changeResponseCountNumber(name, value);
                $ctrl.changeResponseCountLabel(name, value);
            },
            changeResponseCountNumber: function (name, value) {
                $ctrl.onChange({
                    $nodePrefix: RESPONSE_COUNT_NUMBER,
                    $elementType: FORMATS.RESPONSE_COUNT_NUMBER,
                    $name: name,
                    $value: value
                });
            },
            changeResponseCountLabel: function (name, value) {
                $ctrl.onChange({
                    $nodePrefix: RESPONSE_COUNT_LABEL,
                    $elementType: FORMATS.RESPONSE_COUNT_LABEL,
                    $name: name,
                    $value: value
                });
            },
            changeHeader: function (name, value) {
                $ctrl.onChange({
                    $nodePrefix: HEADER_PREFIX,
                    $elementType: FORMATS.TABLE_HEADER_TEXT,
                    $name: name,
                    $value: value
                });
            },
            changeBody: function (name, value) {
                $ctrl.onChange({
                    $nodePrefix: BODY_PREFIX,
                    $elementType: FORMATS.TABLE_BODY_TEXT,
                    $name: name,
                    $value: value
                });
            },
            changeChart: function (name, value) {
                $ctrl.onChange({
                    $nodePrefix: CHART_PREFIX,
                    $elementType: FORMATS.CHART_TEXT,
                    $name: name,
                    $value: value
                });
            },
            changeChartAdv: function (name, value, section) {
                $ctrl.onChange({
                    $nodePrefix: CHART_PREFIX,
                    $elementType: FORMATS.CHART_TEXT,
                    $name: name,
                    $value: value,
                    $section: section,
                    $advStyle: $ctrl.widgetStyle.chartTextFormats
                });
            },
            resetResponseCount: function () {
                $ctrl.resetResponseCountNumber();
                $ctrl.resetResponseCountLabel();
            },
            resetResponseCountNumber: function () {
                $ctrl.onReset({
                    $nodePrefix: RESPONSE_COUNT_NUMBER,
                    $elementType: FORMATS.RESPONSE_COUNT_NUMBER,
                });
            },
            resetResponseCountLabel: function () {
                $ctrl.onReset({
                    $nodePrefix: RESPONSE_COUNT_LABEL,
                    $elementType: FORMATS.RESPONSE_COUNT_LABEL,
                });
            },
            resetHeader: function () {
                $ctrl.onReset({
                    $nodePrefix: HEADER_PREFIX,
                    $elementType: FORMATS.TABLE_HEADER_TEXT,
                });
            },
            resetBody: function () {
                $ctrl.onReset({
                    $nodePrefix: BODY_PREFIX,
                    $elementType: FORMATS.TABLE_BODY_TEXT
                });
            },
            resetChart: function () {
                $ctrl.onReset({
                    $nodePrefix: CHART_PREFIX,
                    $elementType: FORMATS.CHART_TEXT
                });
            },
            changeTableBodyDensity: function (density) {
                $ctrl.tableBodyDensity = density;
                $ctrl.onChange({
                    $nodePrefix: TABLE_DENSITY_PREFIX,
                    $elementType: 'tableBodyDensity',
                    $value: density
                });
            },
            convertBasicToAdv: function () {
                var advChartTextFormats = {};
                _.forEach($ctrl.chartAdvSections[$ctrl.widgetType], function (section) {
                    advChartTextFormats[section.label] = _.cloneDeep($ctrl.widgetStyle.chartTextFormats);
                    if (_.includes(CHART_NO_SIZE, $ctrl.widgetId)) {
                        advChartTextFormats[section.label] = _.omit(advChartTextFormats[section.label], ['SIZE']);
                    }
                });
                $ctrl.widgetStyle.chartTextFormats = advChartTextFormats;
                updateChartTextFormats();
            },
            getTableBodyDensity: function () {
                return _.get(flowingPages.getWidget($ctrl.widgetId), 'layout.style.tableBodyDensity', null);
            },
            changeFilterSummary: function (name, value, section) {
                $ctrl.onChange({
                    $nodePrefix: FILTER_SUMMARY_PREFIX,
                    $elementType: FORMATS.FILTER_SUMMARY_TEXT_FORMATS,
                    $name: name,
                    $value: value,
                    $section: section
                });
            },
        });
        function validateResponseCountStyle(style) {
            var defaultStyle = getDefaultStyle();
            var widgetStyle = _.cloneDeep(style) || {};
            var responseCountFormats = [
                FORMATS.RESPONSE_COUNT_NUMBER,
                FORMATS.RESPONSE_COUNT_LABEL
            ];
            _.forEach(responseCountFormats, function (format) {
                // response count/label will default based on body text format
                if (_.isUndefined(widgetStyle[format])) {
                    widgetStyle[format] = defaultStyle[FORMATS.BODY_TEXT_FORMATS];
                }
            });
            return widgetStyle;
        }
        function validateTableStyle(style) {
            style = validateResponseCountStyle(style);
            var defaultStyle = getDefaultStyle();
            var widgetStyle = _.cloneDeep(style) || {};
            if (!_.get(widgetStyle, FORMATS.TABLE_HEADER_TEXT)) {
                widgetStyle.tableHeaderTextFormats = defaultStyle.tableHeaderTextFormats;
            }
            else {
                _.forEach(TEXT_FORMAT_OPTIONS, function (option) {
                    if ((option === 'FONT' || option === 'SIZE') && !_.find($ctrl.tableHeaderTextFormatOptions[option].items, { 'value': widgetStyle.tableHeaderTextFormats[option] })) {
                        widgetStyle.tableHeaderTextFormats[option] = defaultStyle.tableHeaderTextFormats[option];
                    }
                    else if (option === 'COLOR' && !widgetStyle.tableHeaderTextFormats[option]) {
                        widgetStyle.tableHeaderTextFormats[option] = defaultStyle.tableHeaderTextFormats[option];
                    }
                    else if (option === 'BOLD' && _.isUndefined(widgetStyle.tableHeaderTextFormats[option])) {
                        widgetStyle.tableHeaderTextFormats[option] = defaultStyle.tableHeaderTextFormats[option];
                    }
                });
            }
            if (!_.get(widgetStyle, FORMATS.TABLE_BODY_TEXT)) {
                widgetStyle.tableBodyTextFormats = defaultStyle.tableBodyTextFormats;
            }
            else {
                _.forEach(TEXT_FORMAT_OPTIONS, function (option) {
                    if ((option === 'FONT' || option === 'SIZE') && !_.find($ctrl.tableBodyTextFormatOptions[option].items, { 'value': widgetStyle.tableBodyTextFormats[option] })) {
                        widgetStyle.tableBodyTextFormats[option] = defaultStyle.tableBodyTextFormats[option];
                    }
                    else if (option === 'COLOR' && !widgetStyle.tableBodyTextFormats[option]) {
                        widgetStyle.tableBodyTextFormats[option] = defaultStyle.tableBodyTextFormats[option];
                    }
                });
            }
            if (_.isUndefined(widgetStyle.enableAltRows)) {
                var widgetType = _.get(flowingPages.getWidget($ctrl.widgetId), '_type');
                widgetStyle.enableAltRows = (widgetType === 'eng.grid'); //Existing grid widgets maintain alternating rows
            }
            if (_.isUndefined(widgetStyle.repeatTableHeaders)) {
                widgetStyle.repeatTableHeaders = false;
            }
            if (_.isUndefined(widgetStyle.hideTableHeader)) {
                widgetStyle.hideTableHeader = false;
            }
            if (_.isUndefined(widgetStyle.enableFirstColumnWidth)) {
                widgetStyle.enableFirstColumnWidth = false;
            }
            if (_.isUndefined(widgetStyle.firstColumnWidth)) {
                widgetStyle.firstColumnWidth = 50;
            }
            return widgetStyle;
        }
        function validateChartStyle(style) {
            style = validateResponseCountStyle(style);
            var defaultStyle = getDefaultStyle();
            var widgetStyle = _.cloneDeep(style) || {};
            if (!_.get(widgetStyle, FORMATS.CHART_TEXT)) {
                widgetStyle.chartTextFormats = defaultStyle.chartTextFormats;
            }
            else if (!_.isEmpty(_.intersection(TEXT_FORMAT_OPTIONS, _.keys(widgetStyle.chartTextFormats)))) {
                _.forEach(TEXT_FORMAT_OPTIONS, function (option) {
                    if ((option === 'FONT' || option === 'SIZE') && !_.find($ctrl.chartTextFormatOptions[option].items, { 'value': widgetStyle.chartTextFormats[option] })) {
                        widgetStyle.chartTextFormats[option] = defaultStyle.chartTextFormats[option];
                    }
                    else if (option === 'COLOR' && !widgetStyle.chartTextFormats[option]) {
                        widgetStyle.chartTextFormats[option] = defaultStyle.chartTextFormats[option];
                    }
                });
                if (_.includes(CHART_NO_SIZE, $ctrl.widgetId)) {
                    widgetStyle.chartTextFormats = _.omit(widgetStyle.chartTextFormats, ['SIZE']);
                }
            }
            else {
                // Advanced chart style
                _.forEach(chartAdvSections[$ctrl.widgetType], function (section) {
                    widgetStyle.chartTextFormats[section.label] = widgetStyle.chartTextFormats[section.label] || {};
                    _.forEach(TEXT_FORMAT_OPTIONS, function (option) {
                        if ((option === 'FONT' || option === 'SIZE') && !_.find($ctrl.chartTextFormatOptions[option].items, { 'value': widgetStyle.chartTextFormats[section.label][option] })) {
                            widgetStyle.chartTextFormats[section.label][option] = defaultStyle.chartTextFormats[option];
                        }
                        else if (option === 'COLOR' && !widgetStyle.chartTextFormats[section.label][option]) {
                            widgetStyle.chartTextFormats[section.label][option] = defaultStyle.chartTextFormats[option];
                        }
                    });
                    if (_.includes(CHART_NO_SIZE, $ctrl.widgetId)) {
                        widgetStyle.chartTextFormats[section.label] = _.omit(widgetStyle.chartTextFormats[section.label], ['SIZE']);
                    }
                });
            }
            return widgetStyle;
        }
        function validateFilterSummaryStyle(style) {
            var defaultStyle = getDefaultStyle();
            var widgetStyle = _.cloneDeep(style) || {};
            widgetStyle.filterSummaryTextFormats = widgetStyle.filterSummaryTextFormats || {};
            _.forEach(filterSummarySections, function (section) {
                widgetStyle.filterSummaryTextFormats[section.label] = widgetStyle.filterSummaryTextFormats[section.label] || {};
                if (section.label !== 'ALIGNMENT') {
                    _.forEach(TEXT_FORMAT_OPTIONS, function (option) {
                        if ((option === 'FONT' || option === 'SIZE') && !_.find($ctrl.filterTextFormatOptions[option].items, { 'value': widgetStyle.filterSummaryTextFormats[section.label][option] })) {
                            widgetStyle.filterSummaryTextFormats[section.label][option] = defaultStyle.filterSummaryTextFormats[option];
                        }
                        else if (option === 'COLOR' && !widgetStyle.filterSummaryTextFormats[section.label][option]) {
                            widgetStyle.filterSummaryTextFormats[section.label][option] = defaultStyle.filterSummaryTextFormats[option];
                        }
                    });
                }
                else {
                    widgetStyle.filterSummaryTextFormats[section.label][section.label] = widgetStyle.filterSummaryTextFormats[section.label][section.label] || defaultStyle.filterSummaryTextFormats[section.label];
                }
            });
            return widgetStyle;
        }
        function getDefaultStyle() {
            return _.pick(globalOptionsService.getOptions(), _.values(FORMATS));
        }
        function updateTableTextFormats() {
            updateResponseCountFormats();
            addCurrentFormats($ctrl.tableHeaderTextFormatOptions, $ctrl.widgetStyle.tableHeaderTextFormats);
            addCurrentFormats($ctrl.tableBodyTextFormatOptions, $ctrl.widgetStyle.tableBodyTextFormats);
        }
        function updateChartTextFormats() {
            updateResponseCountFormats();
            if ($ctrl.widgetStyle.chartTextFormats.FONT) {
                addCurrentFormats($ctrl.chartTextFormatOptions, $ctrl.widgetStyle.chartTextFormats);
            }
            else {
                _.forEach($ctrl.chartAdvSections[$ctrl.widgetType], function (section) {
                    _.merge(section, $ctrl.widgetStyle.chartTextFormats[section.label]);
                });
            }
        }
        function updateFilterSummaryTextFormats() {
            _.forEach($ctrl.filterSummarySections, function (section) {
                _.merge(section, $ctrl.widgetStyle.filterSummaryTextFormats[section.label]);
            });
        }
        function updateResponseCountFormats() {
            addCurrentFormats($ctrl.responseCountNumberOptions, $ctrl.widgetStyle.responseCountNumberFormats);
            addCurrentFormats($ctrl.responseCountLabelOptions, $ctrl.widgetStyle.responseCountLabelFormats);
        }
        function addCurrentFormats(formatOptions, currentTextFormats) {
            formatOptions.FONT.selectedFormat = currentTextFormats.FONT;
            formatOptions.SIZE.selectedFormat = currentTextFormats.SIZE;
            formatOptions.COLOR.selectedColor = currentTextFormats.COLOR;
            formatOptions.BOLD.selectedFormat = currentTextFormats.BOLD;
        }
    }
    module.component('prWidgetStyleSelector', {
        templateUrl: widget_style_selector_html_1.default,
        controller: WidgetStyleController,
        bindings: {
            widgetId: '<',
            widgetType: '<',
            currentStyle: '<',
            onChange: '&',
            onReset: '&',
            onChangeAltRows: '&',
            onRepeatTableHeaders: '&',
            onHideTableHeader: '&',
            onEnableFirstColumnWidth: '&',
            onSetFirstColumnWidth: '&',
            unit: '<'
        }
    });
})(angular.module('qualtrics.pr'));
